import { controls } from "../../controls";

const rp1010 = {
  label: "Failed ATM Reversals",
  pageLabel: "Failed ATM Reversals",
  starting: true,
  url: "rp1010",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"from_date",width:"col-sm-2"}),
    

    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"to_date",width:"col-sm-2"}),
    

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "Failed Reversal",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Record No.",
        accessor: "recno",
        width: 180,
        rwidth: 100
      },
      {
        Header: "Date",
        accessor: "date",
        type:"date",
        width: 130,
        rwidth: 75
      },
      {
        Header: "Time",
        accessor: "time",
        width: 130,
        rwidth: 75
      },
      {
        Header: "Terminal ID",
        accessor: "terminal_id",
        width: 180,
        rwidth: 100
      },
      {
        Header: "A/C No.",
        accessor: "acct_no",
        width: 225,
        rwidth: 125
      },
      {
        Header: "Card No.",
        accessor: "card_no",
        width: 250,
        rwidth: 125
      },      
      {
        Header: "Amount",
        accessor: "amount",
        type:"currency",
        rwidth: 100
      }
    ]
  }
};

export default rp1010;